import { toast } from "react-toastify";

export const toastSuccess = (message: string) => {
  toast.success(message, {
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    progress: undefined,
    theme: "dark",
    style: {
      background: `rgba(0, 0, 0, 0.9)`,
    },
    bodyStyle: {
      background: `rgba(0, 0, 0, 0.9)`,
    },
    progressStyle: {
      background: `rgba(204, 204, 204, 0.9)`,
    },
  });
};

export const toastError = (message: string) => {
  toast.error(message, {
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    progress: undefined,
    theme: "dark",
    style: {
      background: `rgba(0, 0, 0, 0.9)`,
    },
    bodyStyle: {
      background: `rgba(0, 0, 0, 0.9)`,
    },
    progressStyle: {
      background: `rgba(204, 204, 204, 0.9)`,
    },
  });
};
